import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { LogosLinkComponent } from './logos-link.component'
import { SharedModule } from '../shared/shared.module'
import { LogosLinkIconComponent } from './logos-link-icon/logos-link-icon.component'
import { HeaderLogoComponent } from './header-logo/header-logo.component'



@NgModule({
  declarations: [LogosLinkComponent, LogosLinkIconComponent, HeaderLogoComponent],
  imports: [
    CommonModule,
    SharedModule
  ],
  exports: [LogosLinkComponent],
})
export class LogosLinkModule { }
